import s from './Modal.module.scss';
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg"

export const Modal = ({children, show, setShow, style}: any) => {

    // ### State

    // ### Effects

    // ### Functions

    // ### Views

    return(
        <div className={`${s.wrapper} ${show ? s.active : ''}`} style={style}>
            <div className={s.modal}>
                <div className={s.close} onClick={()=>setShow(false)}><CloseIcon/></div>
                {children}
            </div>
        </div>
    )
}